import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { FrequencySelectorComponent } from './frequency-selector/frequency-selector.component';

@NgModule({
  declarations: [FrequencySelectorComponent],
  imports: [
    CommonModule,
    MatButtonToggleModule,
    FormsModule,
    MatDividerModule,
    MatIconModule,
  ],
  exports: [FrequencySelectorComponent],
})
export class FrequencyModule {}
